import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useSiteConfigState, useStore } from '~/store/composable';
import { setRedirectAfterLogin } from '~/utils/redirectAfterLogin';
import { useRoute } from '@nuxtjs/composition-api';
import { useContext } from '@nuxtjs/composition-api';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageBottomCtas',
  setup(__props) {

const {
  state: { profile },
} = useStore();
const route = useRoute();
const { $auth } = useContext();
const loggedIn = computed(() => profile.user.loggedIn);
const siteConfigState = useSiteConfigState();
const shouldShowFilmNodeBuyPage = computed(
  () => siteConfigState.value?.data?.shouldShowFilmNodeBuyPage,
);
const triggerRegistration = () => {
  if (route?.value?.fullPath) {
    setRedirectAfterLogin(route.value.fullPath);
  }
  return $auth.loginWith('auth0', {
    params: { prompt: 'login', screen_hint: 'signup' },
  });
};

return { __sfc: true,profile, route, $auth, loggedIn, siteConfigState, shouldShowFilmNodeBuyPage, triggerRegistration }
}

})